import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import './CommonUserIcon.css';
import { getImageUrl } from 'utils/common';


const CommonUserIcon = ({ me, onClick }) => {
  return (
    <div
      className="common-user-icon__component"
      style={{ backgroundImage: `url(${me.page_layout === 'avatar' ? getImageUrl(me) : getImageUrl(me, true)})` }}
      onClick={onClick}
      role="button"
      tabIndex={-1}
    />
  );
};

CommonUserIcon.propTypes = {
  me: PropTypes.object,
};

CommonUserIcon.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {},
)(CommonUserIcon);
